import { useParams } from 'react-router-dom';

import { Space } from '../app/entities/space';

export const useCurrentSpace = () => {
  const { spaceId } = useParams() as { spaceId: string };
  return Space.getOne(spaceId)!;
};
